export default {
  apiKey: "AIzaSyBPEl9zgeBFmyiLr1FW-otg7hCqGYkShE0",
  authDomain: "vuefs-prod-2faaa.firebaseapp.com",
  databaseURL: "https://vuefs-prod-2faaa.firebaseio.com",
  projectId: "vuefs-prod-2faaa",
  storageBucket: "vuefs-prod-2faaa.appspot.com",
  messagingSenderId: "79153034557"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js